import styled from 'styled-components';

const Container = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: center;
`;

export default Container;
